import { StyledTitleLoader } from "./styles";

const HeaderContentLoader = () => {
    return (
        <>
            <StyledTitleLoader key="loader-1" />
            <StyledTitleLoader key="loader-2" />
            <StyledTitleLoader key="loader-3" />
        </>
    );
};

export default HeaderContentLoader;
